// https://my.locationiq.com
export const geocodingKey = '00507a4443388c';